import React, { useEffect } from 'react'
import { HStack } from '@chakra-ui/react'
import { useHistory, useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'
import { Axios, handleAxiosError } from '../utils'
import { ROUTES } from '../contants'
import { Loader } from '../components'

const Verify = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    ;(async () => {
      const query = new URLSearchParams(location.search)
      const token = query.get('token')
      if (token) {
        try {
          await Axios.patch(`auth/confirm-email`, { token })
          toast.success('Email verified successfully')
          history.push(ROUTES.login)
        } catch (error: any) {
          history.push(ROUTES.login)
          handleAxiosError(error)
        }
      } else {
        toast.success('Token is required')
        history.push(ROUTES.login)
      }
    })()
  }, [history, location.search])

  return (
    <HStack h="100vh" justify="center" align="center">
      <Loader loading text="Verifying your account" />
    </HStack>
  )
}

export { Verify }
